import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath';
import { all_routes } from '../../../../core/data/routes/all_routes';
import BreadCrumb from '../../common/breadcrumb/breadCrumb';
import confetti from 'canvas-confetti';

const BookingDone = () => {
  const routes = all_routes;
  const location = useLocation();

  useEffect(() => {
    const fireConfetti = () => {
      const duration = 3 * 1000; // 3 seconds
      const animationEnd = Date.now() + duration;
      const colors = ['#ff0000', '#ff7300', '#ffeb00', '#0cff00', '#00f0ff', '#2b65ff', '#a300ff'];
      
      (function frame() {
        const timeLeft = animationEnd - Date.now();
        if (timeLeft <= 0) return;

        confetti({
          particleCount: 10,
          startVelocity: 30,
          spread: 360,
          origin: { x: Math.random(), y: Math.random() - 0.2 },
          colors: colors,
        });

        requestAnimationFrame(frame);
      })();
    };

    fireConfetti();
  }, []);

  return (
    <>
      <BreadCrumb title='Bookings' item1='Customer' item2='Done' />
      <div className="page-wrapper">
        <div className="content"
          style={{
            backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <ul className="step-register row">
                  <li className="activate col-md-3">
                    <div className="multi-step-icon">
                      <span>
                        <ImageWithBasePath src="assets/img/icons/calendar-icon.svg" alt="img" />
                      </span>
                    </div>
                    <div className="multi-step-info">
                      <h6 style={{ color: '#fff' }}>Appointment</h6>
                      <p style={{ color: '#fff' }}>Choose time &amp; date for the service</p>
                    </div>
                  </li>
                  <li className="activate col-md-3">
                    <div className="multi-step-icon">
                      <span>
                        <ImageWithBasePath src="assets/img/icons/choose-icon-3.svg" alt="img" />
                      </span>
                    </div>
                    <div className="multi-step-info">
                      <h6 style={{ color: '#fff' }}>Waiting For Technician</h6>
                      <p style={{ color: '#fff' }}>Accept the technician for service</p>
                    </div>
                  </li>
                  <li className="activate col-md-3">
                    <div className="multi-step-icon">
                      <ImageWithBasePath src="assets/img/icons/wallet-icon.svg" alt="img" />
                    </div>
                    <div className="multi-step-info">
                      <h6 style={{ color: '#fff' }}>Payment</h6>
                      <p style={{ color: '#fff' }}>Select Payment Gateway</p>
                    </div>
                  </li>
                  <li className="active col-md-3">
                    <div className="multi-step-icon">
                      <span>
                        <ImageWithBasePath src="assets/img/icons/book-done.svg" alt="img" />
                      </span>
                    </div>
                    <div className="multi-step-info">
                      <h6 style={{ color: '#fff' }}>Done</h6>
                      <p style={{ color: '#fff' }}>Completion of Booking</p>
                    </div>
                  </li>
                </ul>
                <div className="row align-items-center">
                  <div className="col-md-5">
                    <div className="booking-done">
                      <ImageWithBasePath
                        src="assets/img/payment-success.svg"
                        className="img-fluid"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="booking-done">
                      <h6 style={{ color: '#fff' }}>Successfully Completed Payment</h6>
                      <p style={{ color: '#fff' }}>Your Booking has been Successfully Completed</p>
                      <div className="book-submit">
                        <Link to={routes.index} className="btn btn-dark">
                          <i className="feather icon-arrow-left-circle" /> Go to Home
                        </Link>
                        <Link to={routes.bookingDetails} className="btn btn-light" style={{ color: '#fff' }}>
                          Booking History
                        </Link>
                        <Link to={routes.invoice} className="btn btn-info bg-[#FF008A]">
                          View Receipt
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingDone;